import { DIST_EPSILON } from "./core";

export function rangeNonInclusiveByCount(start: number, end: number, count: number) {
  const step = (end - start) / (count + 1);
  return rangeInclusiveByStep(start + step, end - step, step);
}

export function rangeInclusiveByCount(start: number, end: number, count: number) {
  const step = (end - start) / (count - 1);
  return rangeInclusiveByStep(start, end, step);
}

export function rangeInclusiveByStep(start: number, end: number, step: number) {
  const vs: number[] = [];

  if (step <= 0) {
    return [];
  }

  const endPlusEpsilon = end + Math.min(DIST_EPSILON, step);
  for (let i = start; i <= endPlusEpsilon; i += step) {
    vs.push(i);
  }

  return vs;
}

export function rangeNonInclusiveByMaxStep(start: number, end: number, maxStep: number) {
  const count = Math.ceil((end - start) / maxStep) - 1;
  return rangeNonInclusiveByCount(start, end, count);
}

export function rangeInclusiveByMaxStep(start: number, end: number, maxStep: number) {
  return [start, ...rangeNonInclusiveByMaxStep(start, end, maxStep), end];
}

/**
 * @deprecated Use {@link rangeNonInclusiveByMaxStep} instead.
 *
 * Despite the name, the function ~almost~ treats minStep as a maximum allowed spacing, with an
 * off-by-one error when the range is exactly divisible by spacing.  When the span is an exact
 * multiple of the range, the resulting uniform step is smaller than necessary. Deprecating
 * because of both the misleading name and the incorrect edge case handling.
 */
export function rangeNonInclusiveByMinStep(start: number, end: number, minStep: number) {
  const count = ((end - start) / minStep) | 0;
  return rangeNonInclusiveByCount(start, end, count);
}

/**
 * @deprecated Use {@link rangeInclusiveByMaxStep} instead.
 *
 * See {@link rangeNonInclusiveByMinStep} for the legacy count formula and its spacing issues.
 */
export function rangeInclusiveByMinStep(start: number, end: number, minStep: number) {
  return [start, ...rangeNonInclusiveByMinStep(start, end, minStep), end];
}
